import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  followUp: [], // will store follow-up list
  followUpResponse: null, // optional: store single follow-up response
  error: null,
  message: null,
  distinctTitle: [],
  distinctTitleLoading: false,
  distinctTitleError: null,
  followUpById: null,
  followUpByIdLoading: false,
  followUpByIdError: null,
  followUpCounts: {
    total: 0,
    inProgress: 0,
    completed: 0,
    hold: 0,
    closed: 0,
    created: 0,
  },
  followUpCountsLoading: false,
  followUpCountsError: null,
};

const followUpSlice = createSlice({
  name: 'followUp',
  initialState,
  reducers: {
    // Create FollowUp
    createFollowUpRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createFollowUpSuccess: (state, action) => {
      state.loading = false;
      state.message =
        action.payload?.message || 'Follow-up created successfully';
    },
    createFollowUpFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Failed to create follow-up';
    },

    // Update/Edit FollowUp
    updateFollowUpRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateFollowUpSuccess: (state, action) => {
      state.loading = false;
      state.message =
        action.payload?.message || 'Follow-up updated successfully';
    },
    updateFollowUpFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Failed to update follow-up';
    },

    // Get FollowUp
    getFollowUpRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getFollowUpSuccess: (state, action) => {
      state.loading = false;
      // Ensure followUp is always an array
      state.followUp = Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
    },
    getFollowUpFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || 'Failed to fetch follow-up';
    },
    // Get FollowUp By Using lead
    getFollowUpsByDateRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getFollowUpsByDateSuccess: (state, action) => {
      state.loading = false;
      state.followUp = Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
      state.total = action.payload?.total || 0;
    },
    getFollowUpsByDateFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    getDistinctFollowupTitlesRequest: (state) => {
      state.distinctTitleLoading = true;
      state.distinctTitleError = null;
    },
    getDistinctFollowupTitlesSuccess: (state, action) => {
      state.distinctTitleLoading = false;
      state.distinctTitle = Array.isArray(action.payload?.data)
        ? action.payload.data
        : [];
    },
    getDistinctFollowupTitlesFailure: (state, action) => {
      state.distinctTitleLoading = false;
      state.distinctTitleError =
        action.payload || 'Failed to fetch distinct titles';
    },
    // Get FollowUp By Id — fully separate state
    getFollowUpByIdRequest: (state) => {
      state.followUpByIdLoading = true;
      state.followUpByIdError = null;
    },
    getFollowUpByIdSuccess: (state, action) => {
      state.followUpByIdLoading = false;
      state.followUpById = action.payload?.data || null;
    },
    getFollowUpByIdFailure: (state, action) => {
      state.followUpByIdLoading = false;
      state.followUpByIdError = action.payload || 'Failed to fetch follow-up';
      state.followUpById = null;
    },
    clearFollowUpById: (state) => {
      state.followUpById = null;
      state.followUpByIdError = null;
    },
    getFollowUpCountsRequest: (state) => {
      state.followUpCountsLoading = true;
      state.followUpCountsError = null;
    },
    getFollowUpCountsSuccess: (state, action) => {
      state.followUpCountsLoading = false;
      state.followUpCounts = {
        total: action.payload?.data?.total || 0,
        inProgress: action.payload?.data?.inProgress || 0,
        completed: action.payload?.data?.completed || 0,
        hold: action.payload?.data?.hold || 0,
        closed: action.payload?.data?.closed || 0,
        created: action.payload?.data?.created || 0,
      };
    },
    getFollowUpCountsFailure: (state, action) => {
      state.followUpCountsLoading = false;
      state.followUpCountsError =
        action.payload || 'Failed to fetch follow-up counts';
    },

    clearFollowUp: (state) => {
      state.followUp = [];
    },
  },
});

export const {
  createFollowUpRequest,
  createFollowUpSuccess,
  createFollowUpFailure,
  updateFollowUpRequest,
  updateFollowUpSuccess,
  updateFollowUpFailure,
  getFollowUpRequest,
  getFollowUpSuccess,
  getFollowUpFailure,
  getFollowUpsByDateRequest,
  getFollowUpsByDateSuccess,
  getFollowUpsByDateFailure,
  getDistinctFollowupTitlesRequest,
  getDistinctFollowupTitlesSuccess,
  getDistinctFollowupTitlesFailure,
  getFollowUpByIdRequest,
  getFollowUpByIdSuccess,
  getFollowUpByIdFailure,
  clearFollowUpById,
  getFollowUpCountsRequest,
  getFollowUpCountsSuccess,
  getFollowUpCountsFailure,
  clearFollowUp,
} = followUpSlice.actions;

export default followUpSlice.reducer;
